import { useTranslation } from 'react-i18next';
import { Chip, Group, Select } from '@mantine/core';
import { renderBasisOption, type BasisComboboxItem } from './basisOption';

export type BasisOption = BasisComboboxItem; // value = «address|title», label = «Название — адрес»

interface BuyFilterBarProps {
  /** Базисы, в которых есть объявления о покупке (из дерева закупок). */
  readonly bases: readonly BasisOption[];
  readonly goods: readonly string[];
  readonly basis: string | null;
  readonly good: string | null;
  readonly onBasis: (value: string | null) => void;
  readonly onGood: (value: string | null) => void;
}

// Фильтры списка закупок — тот же паттерн, что переключатель на детали (единообразие):
// базис — Select (поиск по названию и адресу через label), культура — чипы (один клик,
// повторный снимает). Опции выводятся из моих данных. Год урожая в фильтрах НЕ участвует.
export default function BuyFilterBar({ bases, goods, basis, good, onBasis, onGood }: BuyFilterBarProps) {
  const { t } = useTranslation();

  return (
    // maxWidth/minWidth: без них ширина группы равна ширине Select (520), и его maw="100%" ничего не ограничивал —
    // на телефоне фильтр выходил за край экрана и давал горизонтальную прокрутку страницы.
    <Group gap="md" wrap="wrap" align="center" style={{ minWidth: 0, maxWidth: '100%' }}>
      {bases.length > 1 ? (
        <Select
          aria-label={t('app.buy.filterBasis')}
          placeholder={t('app.buy.allBases')}
          data={bases as BasisOption[]}
          renderOption={renderBasisOption}
          value={basis}
          onChange={onBasis}
          clearable
          searchable={bases.length > 6}
          // Опции «Название — адрес» длинные, справа в строке фильтров есть запас — даём ширину;
          // maw не пускает за край на узких экранах.
          w={520}
          maw="100%"
        />
      ) : null}
      {goods.length > 1 ? (
        <Group gap={6} wrap="wrap" role="group" aria-label={t('app.buy.filterGoods')}>
          {goods.map((name) => (
            <Chip
              key={name}
              checked={good === name}
              onChange={(checked) => onGood(checked ? name : null)}
              color="brand"
              size="sm"
            >
              {name}
            </Chip>
          ))}
        </Group>
      ) : null}
    </Group>
  );
}
